import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetCategory() {
  const project = useCurrentProject();
  const params = useParams();

  const categoryId = Number(params.categoryId);

  return useQuery({
    queryKey: [project, 'category', params.categoryId],
    queryFn: () => Api.categories.getCategory(project, categoryId),
    enabled: !!categoryId,
  });
}

export function useGetCategoryBooks() {
  const project = useCurrentProject();
  const params = useParams();

  const categoryId = Number(params.categoryId);

  return useQuery({
    queryKey: [project, 'category-books', params.categoryId],
    initialData: {
      books: [],
      count: 0,
    },
    queryFn: () =>
      Api.books.getBooks(project, {
        limit: 100,
        offset: 0,
        categoryIds: [categoryId],
      }),
    enabled: !!categoryId,
  });
}
